/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Role_HimpunanInputs */

const en_cp_role_himpunan = /** @type {(inputs: Cp_Role_HimpunanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student society / GDG on Campus`)
};

const id_cp_role_himpunan = /** @type {(inputs: Cp_Role_HimpunanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Himpunan / UKM / GDG on Campus`)
};

/**
* | output |
* | --- |
* | "Student society / GDG on Campus" |
*
* @param {Cp_Role_HimpunanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_role_himpunan = /** @type {((inputs?: Cp_Role_HimpunanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Role_HimpunanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_role_himpunan(inputs)
	return en_cp_role_himpunan(inputs)
});